// test668
(668 && 0);
